@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.color-picker-container {
  margin-right: 45px;
  .color-input {
    display: flex;
    align-items: center;
    max-width: 200px;

    .color-swatch-container {
      position: relative;
      height: 32px;
    }
  }

  .color-input-element {
    border-radius: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-left: none;
    font-size: 14px;
    height: 32px;
    max-width: 169px;
  }

  .input-has-error {
    border-color: @settings-page--branding-input--error--border-color;
    border-width: 2px;
    border-left: 2px solid @settings-page--branding-input--error--border-color;
  }

  .error-message {
    color: @settings-page--branding-input--error--text-color;
    font-size: 14px;
    margin-top: 10px;
  }
}
